import {
  Loading03Icon,
  MinusSignIcon,
  Tick01Icon
} from "@hugeicons-pro/core-solid-rounded";
import { InformationCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { useMemo } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components/Badge";
import { ScreeningStatus } from "shared/types";
import { screeningStatusTitle } from "./title";
import { cx } from "shared/utils";

export const ScreeningStatusBadge = ({
  status,
  className
}: {
  status?: string;
  className?: string;
}) => {
  const { variant, title, icon } = useMemo(() => {
    switch (status) {
      case ScreeningStatus.Processing:
        return {
          icon: <HugeiconsIcon icon={Loading03Icon} size={12} />,
          variant: BadgeVariant.WARNING,
          title: screeningStatusTitle(status)
        };
      case ScreeningStatus.Completed:
        return {
          icon: <HugeiconsIcon icon={Tick01Icon} size={12} />,
          variant: BadgeVariant.PRIMARY,
          title: screeningStatusTitle(status)
        };
      case ScreeningStatus.Failed:
        return {
          icon: <HugeiconsIcon icon={InformationCircleIcon} size={12} />,
          variant: BadgeVariant.ERROR,
          title: screeningStatusTitle(status)
        };
      case ScreeningStatus.NotStarted:
      default:
        return {
          icon: <HugeiconsIcon icon={MinusSignIcon} size={12} />,
          variant: BadgeVariant.BASE,
          title: screeningStatusTitle(status)
        };
    }
  }, [status]);

  return (
    <Badge
      className={cx("shrink-0 items-center", className)}
      variant={variant}
      size={BadgeSize.SM}
      leftElement={icon}
    >
      {title}
    </Badge>
  );
};
